module.exports = "<!--\n * Copyright 2017 Control4 Corporation. All rights reserved.\n * Control4 Confidential and Proprietary Information.\n-->\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstarts.component.html
// module id = 1611
// module chunks = 2